"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.213 6.31c0-.718-.875-1.072-1.375-.555l-3.15 3.26a2.7 2.7 0 0 1-1.942.824H5.2a.8.8 0 0 0-.8.8v2.723a.8.8 0 0 0 .8.8h.546a2.7 2.7 0 0 1 1.942.823l3.15 3.26a.8.8 0 0 0 1.375-.556zM9.831 4.783c1.374-1.422 3.782-.45 3.782 1.529V17.69c0 1.978-2.408 2.951-3.782 1.529l-3.15-3.26a1.3 1.3 0 0 0-.935-.396H5.2a2.2 2.2 0 0 1-2.2-2.2V10.64a2.2 2.2 0 0 1 2.2-2.2h.546a1.3 1.3 0 0 0 .935-.397zm5.265 3.47a.7.7 0 0 1 .966-.217c1.218.769 1.983 2.288 1.983 3.968s-.765 3.2-1.986 3.963a.7.7 0 1 1-.741-1.188c.74-.462 1.327-1.488 1.327-2.775 0-1.285-.586-2.315-1.33-2.785a.7.7 0 0 1-.219-.966",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.237 5.554a.7.7 0 0 1 .987-.073C19.924 6.945 21 9.337 21 12.003c0 2.662-1.075 5.051-2.771 6.517a.7.7 0 1 1-.915-1.06c1.356-1.171 2.286-3.157 2.286-5.457 0-2.305-.932-4.291-2.29-5.462a.7.7 0 0 1-.073-.987",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MuteIcon24.js.map